import React, { Component } from "react";

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  Button,
} from "mdbreact";
import { Card, CardHeader } from "reactstrap";
import BreadCumb from "../Department/BreadCumb";
import { PostData } from "../../api/service";

// const facultyData = [
//     {
//         name: 'Dr. Jogesh Kakati',
//         desg: 'Principal',
//         qualification: 'MA, PhD',
//         email: '',
//         phone: '',
//         mobile: '',
//         specifications: '',
//         cv: '',
//         photo: ''
//     },

// ]

export default class PrincipalContainer extends Component {
  state = {
    facultyData: [],
    isLoaded: false,
    dept_code: "OFF",
  };

  componentDidMount() {
    let d = {
      dept_code: "OFF",
      type: "PRINCIPAL",
    };

    PostData(`/getemployeebytype`, d).then((resp) => {
      //console.log(resp)
      this.setState({
        ...resp[0],
        facultyData: resp,
        isLoaded: true,
      });
    });
  }
  render() {
    return (
      <div>
        <MDBContainer style={{ paddingTop: "20px" }}>
          <br />

          {this.state.isLoaded &&
            this.state.facultyData.map((el, index) => {
              return (
                <div>
                  {/* <Card style={{ boxShadow: 'none' }}>
                            <CardHeader style={{ color: 'white', boxShadow: 'none', backgroundColor: '#1E3760', textAlign: 'center' }}> <h3 style={{color: 'inherit'}}>{el.desg}</h3></CardHeader>
                        </Card> */}

                  <div>
                    <img
                      alt=""
                      src={"/images/dc_principal_new_image_1.jpg"}
                      style={{
                        width: "100%",
                        boxShadow: "1px 2px 10px rgba(0,0,0,0.1)",
                        border: `solid 5px wheat`,
                      }}
                    />
                    <MDBRow className="mt-2">
                      <MDBCol lg="12" sm="12" xs="12" md="12">
                        <div className="new-principal-div">
                          <h5
                            style={{
                              textAlign: "center",
                              color: "#1E3760",
                              fontSize: "1.5em",
                              marginTop: "5vh",
                            }}
                          >
                            Principal's Message
                          </h5>
                          <p
                            style={{
                              textAlign: "justify",
                              marginTop: "3vh",
                              fontWeight: 500,
                            }}
                          >
                            <i>Dear Students,</i>
                          </p>
                          <p
                            style={{
                              textAlign: "justify",
                              marginTop: "3vh",
                              fontWeight: 500,
                            }}
                          >
                            <i>
                              It is a moment of profound joy to welcome you to
                              Dispur College—an institution that has, since
                              1978, stood as a sentinel of wisdom at the very
                              heart of Guwahati. Today, our campus is a vibrant
                              ecosystem home to 3,415 dedicated students. This
                              thriving community is the heart of our success,
                              driving us to reach new heights of excellence. Our
                              journey of nearly five decades was recently
                              celebrated with the prestigious NAAC 'A' Grade in
                              November 2024, a testament to our standing as a
                              premier center of learning.
                            </i>
                          </p>
                          <p
                            style={{
                              textAlign: "justify",
                              marginTop: "3vh",
                              fontWeight: 500,
                            }}
                          >
                            <i>
                              As we march toward our Golden Jubilee in 2027-28, our vision is expanding. This upcoming milestone will be marked by the inauguration of a Post-Graduate Research Centre, a Skill and Entrepreneurship Development Centre, and a state-of-the-art mini sports complex. These additions are not merely buildings; they are the foundations upon which your dreams will take flight.
                            </i>
                          </p>

                          <p
                            style={{
                              textAlign: "justify",
                              marginTop: "3vh",
                              fontWeight: 500,
                            }}
                          >
                            <i>
                             In alignment with the National Education Policy (NEP) 2020, which we pioneered with the introduction of the Four-Year Undergraduate Programme (FYUP) in 2023, this session sees a bold leap forward. As we open our gates for the 2026-27 academic session, we are proud to announce that our institution is introducing the Master of Business Administration (MBA), the Integrated Teacher Education Programme (ITEP), and advanced Postgraduate degrees in the fields of Philosophy, Political Science, Accountancy Finance, Human Resource Management and Marketing Management. We believe that education must be a blend of intellectual depth and professional agility-ensuring that knowledge and skill walk hand-in-hand.
                            </i>
                          </p>

                          <p
                            style={{
                              textAlign: "justify",
                              marginTop: "3vh",
                              fontWeight: 500,
                            }}
                          >
                            <i>
Our commitment to you goes beyond the syllabus. We are a sanctuary of inclusivity—a signatory of the UNSG Accord and a vanguard for the LGBTQIA+ community. Through our digital transformation and specialized facilities for Divyangjan students, we ensure that "the mind is without fear and knowledge is held high," as envisioned by Rabindranath Tagore. We aim to foster a "plastic-free and tobacco-free" sanctuary where your health and the environment are as prioritized as your grades.
                            </i>
                            </p>

                            <p
                            style={{
                              textAlign: "justify",
                              marginTop: "3vh",
                              fontWeight: 500,
                            }}
                          >
                            <i>
Dr. A.P.J. Abdul Kalam once reminded us that "Every youth is unique." At Dispur College, our mission is to polish
                            </i>
                            </p>
                          <br />
                          <div style={{ textAlign: "right" }}>
                            <br />
                            <h5 style={{ fontSize: "16px", fontWeight: 700 }}>
                              {el.name}
                            </h5>
                            <h6 style={{ fontSize: "12px" }}>
                              {el.qualification}
                            </h6>
                            <h6 style={{ fontSize: "12px" }}>
                              <a href={`mailto:${el.email}`}>{el.email}</a>
                            </h6>
                            <h6 style={{ fontSize: "12px" }}>
                              <a href={`tel:${el.phone}`}>{el.phone}</a>
                            </h6>
                            <h6 style={{ fontSize: "12px" }}>
                              <a href={`tel:${el.mobile}`}>{el.mobile}</a>
                            </h6>
                            <h6 style={{ fontSize: "12px" }}>
                              {el.specifications}
                            </h6>

                            {this.state.isLoaded &&
                              this.state.id != undefined &&
                              el.liveNow != 0 && (
                                <a
                                  style={{
                                    color: "#1892FF",
                                    cursor: "pointer",
                                    fontWeight: 700,
                                  }}
                                  href={`/department/${this.state.dept_code}/faculty/single?id=${this.state.id}&name=${this.state.name}`}
                                >
                                  Visit Profile
                                </a>
                              )}

                            <br />

                            <a
                              style={{
                                color: "#1892FF",
                                cursor: "pointer",
                                fontWeight: 700,
                              }}
                              href={`/notifications/principal_activity`}
                            >
                              Principal's Monthly Report
                            </a>
                          </div>
                        </div>
                      </MDBCol>

                      {/* <MDBCol lg='12' md="12" sm="12" xs="12">
                                    <br />
                                    <br />
                                    <div style={{ textAlign: 'left' }}>
                                            <img
                                                alt=""
                                                src={'/images/principal_dispurcollege.jpeg'}
                                                style={{ 
                                                    width: '200px', 
                                                    boxShadow: '1px 2px 10px rgba(0,0,0,0.1)',
                                                    border: `solid 5px wheat`
                                             }}
                                            />
                                        </div>
                                        <br />
                                        <h5 style={{fontSize: '16px', fontWeight: 700}}>{el.name}</h5>
                                        <h6 style={{fontSize: '12px'}}>{el.qualification}</h6>
                                        <h6 style={{fontSize: '12px'}}><a href={`mailto:${el.email}`}>{el.email}</a></h6>
                                        <h6 style={{fontSize: '12px'}}><a href={`tel:${el.phone}`}>{el.phone}</a></h6>
                                        <h6 style={{fontSize: '12px'}}><a href={`tel:${el.mobile}`}>{el.mobile}</a></h6>
                                        <h6 style={{fontSize: '12px'}}>{el.specifications}</h6>
                                   
                                        {this.state.isLoaded && this.state.id != undefined && el.liveNow != 0 && <a style={{color: '#1892FF', cursor: 'pointer', fontWeight: 700}} 
              href={`/department/${this.state.dept_code}/faculty/single?id=${this.state.id}&name=${this.state.name}`}>Visit Profile</a>}
                                    </MDBCol> */}
                    </MDBRow>
                  </div>
                </div>
              );
            })}
        </MDBContainer>
      </div>
    );
  }
}
